import React from 'react';
import {
  TextField,
  Button,
  Stack,
  FormControlLabel,
  Switch,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { buildInventorySavePayload } from '../../utils/inventorySettings';
import SelectField from '../inputs/SelectField';

export default function CertifiedInventorySettingsPanel({
  form,
  setField,
  onSave,
  onReset,
  saving,
  shapeOptions = [],
}) {
  const { t } = useTranslation();
  const certified = form.inventorySettings?.certified || {};

  const setCertifiedField = (key, value) => {
    setField('inventorySettings', {
      ...form.inventorySettings,
      certified: { ...certified, [key]: value },
    });
  };

  const handleSave = () => {
    onSave(buildInventorySavePayload(form));
  };

  const shapeSelectOptions = [
    { value: '', label: t('settings.inventory.none') },
    ...shapeOptions.map((s) => ({ value: s, label: s })),
  ];

  return (
    <Stack spacing={2.5}>
      <FormControlLabel
        control={(
          <Switch
            checked={certified.requireShapeFilter === true}
            onChange={(e) => setCertifiedField('requireShapeFilter', e.target.checked)}
            size="small"
          />
        )}
        label={t('settings.inventory.certified.requireShapeFilter')}
      />
      <SelectField
        label={t('settings.inventory.certified.defaultShapeFilter')}
        value={certified.defaultShapeFilter || ''}
        onChange={(value) => setCertifiedField('defaultShapeFilter', value)}
        options={shapeSelectOptions}
        size="small"
        helperText={t('settings.inventory.certified.defaultShapeFilterHelp')}
      />
      <TextField
        label={t('settings.inventory.certified.maxCaratRangeSpan')}
        value={certified.maxCaratRangeSpan ?? ''}
        onChange={(e) => setCertifiedField('maxCaratRangeSpan', e.target.value)}
        type="number"
        inputProps={{ min: 0, step: 0.1 }}
        size="small"
        sx={{ maxWidth: 280 }}
        helperText={t('settings.inventory.certified.maxCaratRangeSpanHelp')}
        placeholder={t('settings.inventory.unlimited')}
      />
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        <TextField
          label={t('settings.inventory.certified.defaultMinCarat')}
          value={certified.defaultMinCarat ?? ''}
          onChange={(e) => setCertifiedField('defaultMinCarat', e.target.value)}
          type="number"
          inputProps={{ min: 0, step: 0.01 }}
          size="small"
          sx={{ maxWidth: 200 }}
        />
        <TextField
          label={t('settings.inventory.certified.defaultMaxCarat')}
          value={certified.defaultMaxCarat ?? ''}
          onChange={(e) => setCertifiedField('defaultMaxCarat', e.target.value)}
          type="number"
          inputProps={{ min: 0, step: 0.01 }}
          size="small"
          sx={{ maxWidth: 200 }}
        />
      </Stack>
      <Stack direction="row" spacing={1}>
        <Button variant="contained" onClick={handleSave} disabled={saving} size="small">
          {saving ? t('common.saving') : t('common.save')}
        </Button>
        <Button onClick={onReset} disabled={saving} size="small">
          {t('common.reset')}
        </Button>
      </Stack>
    </Stack>
  );
}
